import Auth from './Auth'
import IndexPage from './IndexPage' // 首页api接口
import CourseCenter from './CourseCenter'
import Course from './Course'
import NewCourseDetail from './NewCourseDetail'
import Common from './Common'
import Search from './Search'
import AddPurchase from './AddPurchase'
import Teacher from './Teacher'
import RedirectOld from './RedirectOld'
import Article from './Article'
import Feedback from './Feedback'
import SearchPage from './SearchPage'

export {
  Auth,
  IndexPage,
  CourseCenter,
  Course,
  NewCourseDetail,
  Common,
  Search,
  AddPurchase,
  Teacher,
  RedirectOld,
  Article,
  Feedback,
  SearchPage
}



// WEBPACK FOOTER //
// ./src/networks/api/index.js